import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pop-up-footer',
  templateUrl: './pop-up-footer.component.html',
  styleUrls: ['./pop-up-footer.component.scss']
})
export class PopUpFooterComponent implements OnInit {
  @Output() onSubmitNomination = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

}
